import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function About() {
  const [info, setInfo] = useState({ about_us: "" });
  useEffect(() => {
    axios.get(`${API}/public/site-info`).then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  const fallback = `Mahasa er en dansk biludlejning og bilforhandling med fokus på personlig service og kvalitet. Vi startede med en simpel mission: at gøre det nemt at finde den rette bil — uden besvær, uden de store kæders kølighed.

Vores flåde er nøje udvalgt, og hver bil bliver passet på som var den vores egen. Vi tror på langsigtede relationer, og at god service ikke skal være en luksus.

Uanset om du har brug for en bil i en weekend, en måned eller for livet — så er vi her for at hjælpe.`;

  const text = info.about_us || fallback;
  const title = (info.about_title && info.about_title.trim()) || "Mere end biludlejning.";
  const hasImage = typeof info.about_image_url === "string" && info.about_image_url.trim().length > 0;

  return (
    <div className="bg-[#F7F3EC] min-h-screen" data-testid="about-page">
      <section className="py-16 md:py-24 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="label-tag mb-4">Om os</div>
        <h1 className="font-heading text-5xl md:text-6xl text-graphite mb-12 leading-tight">{title}</h1>
        {hasImage && (
          <div className="aspect-[16/9] rounded-2xl overflow-hidden mb-12 bg-[#F1EBE1]">
            <img src={info.about_image_url} alt="" className="w-full h-full object-cover"/>
          </div>
        )}
        <div className="prose prose-lg max-w-none font-body text-graphite/80 whitespace-pre-line leading-relaxed text-base md:text-lg">
          {text}
        </div>
      </section>
    </div>
  );
}
